<button [class]="buttonClass" [disabled]="this.disabled">
	<label *ngIf="label">
		{{ label | translate}}
	</label>
	<app-icon *ngIf="icon" [name]="icon" [color]="colorIcon" size="sm" strokeWidth="regular">
	</app-icon>
	<!-- <img *ngIf="icon" width="16px" [src]="icon" alt="icon-button"/> -->
</button>
